// export const baseURL = "http://192.168.3.129:9099"
// export const baseURL = "http://192.168.7.208:8062"
// export const baseURL = "http://192.168.2.205:3030/mock/115"
// export const baseURL = "http://192.168.2.208:8288/apgw"
// export const baseURL = 'http://118.190.205.234:8288/apgw'
// export const baseURL = 'http://27.221.101.241:8091/apgw'
// export const baseURL = 'http://118.190.205.234:8288/apgw'
// export const baseURL = "http://192.168.7.123:9099"
export const baseURL = 'https://jg.jxy.juxueyun.com/apgw'
// export const baseURL = 'http://192.168.7.208:8288/apgw'
// export const baseURL = 'http://www.juxueyun.com/apgw'